"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var fa_1 = require("react-icons/fa");
var CustomCheckbox = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, value = _a.value, _b = _a.required, required = _b === void 0 ? false : _b, errorMessage = _a.errorMessage, conditionalErrorVisible = _a.conditionalErrorVisible, conditionalErrorMessage = _a.conditionalErrorMessage, tooltip = _a.tooltip, description = _a.description, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, style = _a.style, _d = _a.moreVisible, moreVisible = _d === void 0 ? false : _d, // Varsayılan false
    onChange = _a.onChange;
    // Checkbox kutusu için stil
    var customInputStyle = __assign(__assign({}, style), (moreVisible ? {
        transform: 'scale(1.5)',
        transformOrigin: 'center',
        border: '2px solid #007bff',
        boxShadow: '0 0 5px rgba(0,123,255,0.8)',
        marginTop: '0.6rem',
    } : {}));
    // Label (yazı) için stil
    var customLabelStyle = moreVisible ? {
        fontSize: '1.5em',
        fontWeight: 'bold',
        marginLeft: '0.5rem',
    } : {};
    var inputElement = (react_1.default.createElement("input", { id: id, name: name, type: "checkbox", className: "form-check-input", checked: value, disabled: disabled, onChange: onChange, required: required, style: customInputStyle }));
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: "form-check form-group" },
            tooltip ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "tooltip-".concat(id || name) }, tooltip) }, inputElement)) : (inputElement),
            react_1.default.createElement("label", { htmlFor: id, className: "form-check-label", style: customLabelStyle }, label),
            required && (react_1.default.createElement("div", { className: "invalid-feedback text-danger" },
                react_1.default.createElement("div", { className: "description-icon" },
                    react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                react_1.default.createElement("div", { className: "description-text" },
                    react_1.default.createElement("span", null, errorMessage || 'Bu seçim zorunludur.')))),
            conditionalErrorVisible && (react_1.default.createElement("div", { className: "conditional-error-message text-warning" },
                react_1.default.createElement("div", { className: "description-icon" },
                    react_1.default.createElement(fa_1.FaExclamationTriangle, null)),
                react_1.default.createElement("div", { className: "description-text" },
                    react_1.default.createElement("span", null, conditionalErrorMessage)))),
            description && (react_1.default.createElement("div", { className: "form-description text-secondary" },
                react_1.default.createElement("div", { className: "description-icon" },
                    react_1.default.createElement(fa_1.FaInfoCircle, null)),
                react_1.default.createElement("div", { className: "description-text" },
                    react_1.default.createElement("span", null, description)))))));
};
exports.default = CustomCheckbox;
